import { DROP_SELECTED_ELEMENTS } from "../../actions";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case DROP_SELECTED_ELEMENTS:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          return {
            ...old_layer,
            text_elements: old_layer.text_elements.map((element) => {
              if (element.is_selected) {
                const prevLeft =
                    element.left_position * (state.preview_scale * 72),
                  newLeft =
                    (prevLeft + action.payload.delta.x + action.payload.snapX) /
                    (state.preview_scale * 72),
                  prevTop = element.top_position * (state.preview_scale * 72),
                  newTop =
                    (prevTop + action.payload.delta.y + action.payload.snapY) /
                    (state.preview_scale * 72);
                return {
                  ...element,
                  left_position: newLeft,
                  top_position: newTop,
                };
              } else {
                return element;
              }
            }),
            image_elements: old_layer.image_elements.map((element) => {
              if (element.is_selected) {
                const prevLeft =
                    element.left_position * (state.preview_scale * 72),
                  newLeft =
                    (prevLeft + action.payload.delta.x + action.payload.snapX) /
                    (state.preview_scale * 72),
                  prevTop = element.top_position * (state.preview_scale * 72),
                  newTop =
                    (prevTop + action.payload.delta.y + action.payload.snapY) /
                    (state.preview_scale * 72);
                return {
                  ...element,
                  left_position: newLeft,
                  top_position: newTop,
                };
              } else {
                return element;
              }
            }),
          };
        }),
      };

    default:
      return state;
  }
}
